var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgiUsdtToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 33,
    viewBox: "0 0 66 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36258_200943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7768 0.5L29.5546 8.5V24.5L15.7768 32.5L1.99902 24.5V8.5L15.7768 0.5ZM15.7786 2.27734L28.0256 9.38845V23.6107L15.7786 30.7218L3.53173 23.6107V9.38845L15.7786 2.27734ZM15.7844 4.05664L26.5004 10.2789V22.7233L15.7844 28.9455L5.06834 22.7233V10.2789L15.7844 4.05664ZM14.6649 7.61133L19.9061 10.1344V22.1674L14.6649 24.6905L12.727 23.476V8.82581L14.6649 7.61133ZM14.3875 8.48423L13.6835 8.92543L14.3875 9.19499V8.48423ZM14.3875 9.82928L13.3193 9.42028V22.8814L14.3875 22.4721V9.82928ZM14.9799 22.2452V10.0561L17.6269 11.0696V21.2309L14.9799 22.2452ZM14.3875 23.1065L13.6833 23.3763L14.3875 23.8176V23.1065ZM14.9799 23.8815V22.8795L17.9313 21.7486L18.8153 22.0351L14.9799 23.8815ZM19.3138 21.574L18.2192 21.2192V11.0814L19.3138 10.7276V21.574ZM18.8146 10.2664L17.9313 10.5519L14.9799 9.4218V8.42037L18.8146 10.2664Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_36258_200943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7768 0.5L63.5546 8.5V24.5L49.7768 32.5L35.999 24.5V8.5L49.7768 0.5ZM49.7786 2.27734L62.0256 9.38845V23.6107L49.7786 30.7218L37.5317 23.6107V9.38845L49.7786 2.27734ZM49.8 4.05664L60.5161 10.2789V22.7233L49.8 28.9455L39.084 22.7233V10.2789L49.8 4.05664ZM56.1305 10.5V12.7841H51.6026V14.3677C54.7827 14.5369 57.1686 15.232 57.1863 16.0651L57.1862 17.8019C57.1685 18.635 54.7827 19.33 51.6026 19.4993V23.3857H48.5959V19.4993C45.4158 19.33 43.0298 18.635 43.0121 17.8019L43.0122 16.0651C43.0299 15.232 45.4158 14.5369 48.5959 14.3677V12.7841H44.0679V10.5H56.1305ZM50.1008 18.3035C53.4946 18.3035 56.3312 17.7158 57.0254 16.9309C56.4367 16.2653 54.3074 15.7415 51.6041 15.5977V17.2557C51.1196 17.2815 50.6166 17.2951 50.1008 17.2951C49.585 17.2951 49.082 17.2815 48.5975 17.2557V15.5977C45.8942 15.7415 43.7649 16.2653 43.1762 16.9309C43.8704 17.7158 46.707 18.3035 50.1008 18.3035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36258_200943"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_36258_200943"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgiUsdtToken);
export default __webpack_public_path__ + "static/media/agi-usdt-token.edc8b9cf16452c19545069b2f4800fe2.svg";
export { ForwardRef as ReactComponent };